import React, { useState } from "react";
import down from "../assets/down.png";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getCategory } from "../../store/getCategory";
// import businessData from "../../store/allAddBusinessData";

function Selectcustom({ placeholder }) {
  const [selectedOption, setSelectedOption] = useState("");
  // const selector = useSelector((state) => state.getCategory.data);
  const dispatch = useDispatch();
  const [optionsData, setOptionsData] = useState([]);
  // const { setCategory } = businessData.actions;
const setCategory=null;
const selector=null;
  useEffect(() => {
    dispatch(getCategory());
  }, []);

  useEffect(() => {
    setOptionsData(selector);
  }, [selector]);

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    dispatch(setCategory(event.target.value));
    console.log(event.target.value);
  };
  return (
    <>
      <div
        className="custom-select"
        style={{ position: "relative", width: "100%" }}
      >
        <select
          className="input1"
          style={{ paddingLeft: "10px", width: "100%" }}
          value={selectedOption}
          onChange={handleSelectChange}
        >
          {!optionsData && (
            <option
              className="option1"
              value="option1"
              style={{ fontSize: "16px", fontWeight: "400" }}
            >
              Message Services
            </option>
          )}
          {optionsData &&
            optionsData.map((elem, index) => {
              return (
                <option
                  className="option1"
                  value={elem?.id}
                  style={{ fontSize: "16px", fontWeight: "400" }}
                  key={index}
                >
                  {elem?.category_name}
                </option>
              );
            })}
        </select>
        <div style={{ position: "absolute", top: "5px", right: "10px" }}>
          <img src={down} />
        </div>
      </div>
    </>
  );
}

export default Selectcustom;
